<template>
	<view class="mall">
		<view class="head" :style="{ height: 'calc(' + (navHeight + statusbarHeight + 'px + 188rpx)') }">
			<view class="head-box">
				<view :style="{ width: '100%', height: statusbarHeight + 'px' }"></view>
				<view class="head-search":style="{ height: navHeight + 'px' }">
					<text>商城</text>
					<view class="head-search-input">
						<u-search placeholder="搜索商品" height="30" searchIconColor="#999999" borderColor="#eeeeee"
							bgColor="rgba(255,255,255,0.9)" :showAction="false" v-model="keyword" />	
					</view>
				</view>
				<view class="head-tabs">
					<u-tabs lineColor="#E4001D" :list="list"></u-tabs>
				</view>
			</view>
			
			<view class="head-list">
				<view class="head-list-item" @click="openSearch(1)">
					<text style="color: #222222; font-weight: 500;">综合排序</text>
					<u-icon name="arrow-down" color="#222222" size="13"></u-icon>
				</view>
				<view class="head-list-item" @click="openSearch(2)">
					<text>适用品牌</text>
					<u-icon name="arrow-down" color="#777777" size="13"></u-icon>
				</view>
				<view class="head-list-item">
					<text>系列</text>
					<u-icon name="arrow-down" color="#777777" size="13"></u-icon>
				</view>
			</view>
			
			<view class="list" v-if="show === 1">
				<view class="list-item">
					<text>综合排序</text>
					<image src="/static/icon/ic_selete@2x.png" mode="widthFix"></image>
				</view>
				<view class="list-item">
					<text>销量由高到低</text>
				</view>
				<view class="list-item">
					<text>价格由低到高</text>
				</view>
			</view>
			
			<view class="list" v-if="show === 2">
				<view class="list-cate active" v-for="(item, index) in 6" :key="index">自营品牌</view>
			</view>
		</view>
		<view class="commodity">
			<!-- <view class="commodity-wu">
				<image src="/static/images/default_search@2x.png" mode="widthFix"></image>
			</view> -->
			<view class="commodity-item" v-for="(item, i) in 16" :key="i" @click="jump()">
				<view class="commodity-item-image">
					<image src="/static/logo.png" mode="widthFix"></image>
				</view>
				<view class="commodity-item-box">
					<view class="commodity-item-box-title">
						曲轴减震器皮带轮A12
					</view>
					<view class="commodity-item-box-price">
						<view class="commodity-item-box-price-a">
							<text>499</text>
							<text>.00</text>
						</view>
						<view class="commodity-item-box-price-b">
							¥699.00
						</view>
					</view>
					<view class="commodity-item-shou">
						<text>已售299</text>
						<view class="commodity-item-shou-add">+</view>
					</view>
				</view>
			</view>
		</view>
		<view class="cart">
			<view class="cart-box">
				<image src="/static/icon/ic_cart@2x.png" mode="widthFix"></image>
				<text>购物车</text>
				<view class="cart-num">12</view>
			</view>
		</view>
	</view>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	export default {
		computed: {
			...mapState(['navHeight', 'statusbarHeight'])
		},
		data() {
			return {
				keyword: '',
				show: null,
				list: [
					{ name: '全部' },
					{ name: '支重轮' },
					{ name: '托轮' },
					{ name: '平衡轮' },
					{ name: '导轨' },
					{ name: '导向轮' },
				]
			};
		},
		methods: {
			openSearch(type) {
				if (type === this.show) {
					this.show = null
				} else {
					this.show = type
				}
			},
			jump() {
				uni.navigateTo({
					url: '/pages/details/details'
				})
			}
		}
	}
</script>

<style>
	page {
		background-color: #F9F9FB;
	}
</style>
<style lang="scss" scoped>
	.mall {
		width: 100%;
		.cart {
			position: fixed;
			right: 30rpx;
			bottom: 100rpx;
			z-index: 999;
			.cart-box {
				width: 88rpx;
				height: 88rpx;
				border-radius: 50%;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				background: rgba(255,255,255,0.96);
				box-shadow: 0rpx 4rpx 12rpx 0rpx rgba(0,0,0,0.16);
				position: relative;
				image {
					width: 35rpx;
					height: 35rpx;
				}
				text {
					font-weight: 400;
					font-size: 20rpx;
					color: #333333;
				}
				.cart-num {
					position: absolute;
					top: -15rpx;
					right: -15rpx;
					border-radius: 50%;
					width: 40rpx;
					height: 40rpx;
					line-height: 40rpx;
					font-weight: 400;
					font-size: 22rpx;
					color: #FFFFFF;
					text-align: center;
					background: #E4001D;
				}
			}
		}
		.commodity {
			width: 100%;
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			justify-content: space-between;
			padding: 20rpx 30rpx;
			box-sizing: border-box;
			.commodity-wu {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				margin-top: 240rpx;
				image {
					width: 320rpx;
					height: 320rpx;
				}
			}
			.commodity-item {
				width: 332rpx;
				background-color: #ffffff;
				margin-bottom: 20rpx;
				.commodity-item-image {
					width: 100%;
					height: 336rpx;
					display: flex;
					align-items: center;
					justify-content: center;
					image {
						width: 100%;
					}
				}
				.commodity-item-box {
					width: 100%;
					padding: 20rpx;
					box-sizing: border-box;
					.commodity-item-box-title {
						font-weight: 600;
						font-size: 30rpx;
						color: #222222;
					}
					.commodity-item-box-price {
						width: 100%;
						display: flex;
						align-items: baseline;
						margin-top: 8rpx;
						.commodity-item-box-price-a {
							display: flex;
							align-items: baseline;
							margin-right: 8rpx;
							text {
								&:nth-child(1) {
									font-weight: bold;
									font-size: 32rpx;
									color: #E4001D;
									&::before {
										content: '￥';
										font-weight: 400;
										font-size: 24rpx;
										color: #E4001D;
									}
								}
								&:nth-child(2) {
									font-weight: 400;
									font-size: 24rpx;
									color: #E4001D;
								}
							}
						}
						.commodity-item-box-price-b {
							font-weight: 400;
							font-size: 22rpx;
							color: #999999;
						}
					}
					.commodity-item-shou {
						width: 100%;
						display: flex;
						align-items: center;
						justify-content: space-between;
						text {
							font-weight: 400;
							font-size: 24rpx;
							color: #999999;
						}
						.commodity-item-shou-add {
							width: 44rpx;
							height: 44rpx;
							background: #004096;
							border-radius: 50%;
							line-height: 44rpx;
							text-align: center;
							font-size: 30rpx;
							color: #fff;
						}
					}
				}
			}
		}
		.head {
			width: 100%;
			position: sticky;
			top: 0;
			left: 0;
			z-index: 999;
			.head-box {
				width: 100%;
				background: linear-gradient( 180deg, #FFD7C8 0%, #FFFFFF 100%);
				.head-search {
					width: 100%;
					padding: 0 30rpx;
					box-sizing: border-box;
					display: flex;
					align-items: center;
					text {
						font-weight: 500;
						font-size: 40rpx;
						color: #111111;
						margin-right: 40rpx;
					}
					.head-search-input {
						width: 374rpx;
					}
				}
				.head-tabs {
					width: 100%;
					height: 100rpx;
					display: flex;
					align-items: flex-end;
					border-bottom: 1rpx solid #E5E5E5;
				}
			}
			.list {
				width: 100%;
				padding: 0 30rpx;
				box-sizing: border-box;
				background-color: #ffffff;
				display: flex;
				align-items: center;
				justify-content: space-between;
				flex-wrap: wrap;
				.active {
					background: rgba(0,64,150,0.1) !important;
					color: #004096 !important;
					font-weight: 500 !important;
				}
				.list-cate {
					width: 216rpx;
					height: 72rpx;
					line-height: 72rpx;
					text-align: center;
					background: #F7F7F7;
					border-radius: 8rpx;
					font-weight: 400;
					font-size: 28rpx;
					color: #333333;
					margin-bottom: 24rpx;
				}
				.list-item {
					width: 100%;
					height: 96rpx;
					display: flex;
					align-items: center;
					justify-content: space-between;
					border-bottom: 1rpx solid #EEEEEE;
					text {
						font-weight: 400;
						font-size: 28rpx;
						color: #222222;
					}
					image {
						width: 24rpx;
						height: 18rpx;
					}
				}
			}
			.head-list {
				width: 100%;
				height: 88rpx;
				display: flex;
				align-items: center;
				background-color: #ffffff;
				.head-list-item {
					flex: 1;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					text {
						font-weight: 400;
						font-size: 28rpx;
						color: #777777;
						margin-right: 8rpx;
					}
				}
			}
		}
	}
</style>